/**
 * Category Grid Swiper Slider
 * Initializes Swiper slider for category cards
 */

class CategorySlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
  }

  init() {
    // Wait for Swiper library to load
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.init(), 100);
      return;
    }

    // Small delay to ensure DOM is ready
    setTimeout(() => this.initSwiper(), 50);
  }

  initSwiper() {
    const swiperElement = this.querySelector('.category-swiper');
    if (!swiperElement || this.swiper) return;

    // Get settings from data attributes
    const slidesDesktop = parseFloat(swiperElement.dataset.slidesDesktop) || 2.3;
    const slidesTablet = parseFloat(swiperElement.dataset.slidesTablet) || 1.7;
    const slidesMobile = parseFloat(swiperElement.dataset.slidesMobile) || 1;
    const spaceBetween = parseInt(swiperElement.dataset.spaceBetween) || 24;
    const autoplay = swiperElement.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperElement.dataset.autoplayDelay) || 5000;

    // Initialize Swiper
    this.swiper = new Swiper(swiperElement, {
      // Core settings
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      watchOverflow: true,
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 0.5,
      freeModeMomentumVelocityRatio: 0.5,

      // Autoplay
      autoplay: autoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,

      // Responsive breakpoints
      breakpoints: {
        // Mobile (>= 480px)
        480: {
          slidesPerView: slidesMobile,
          spaceBetween: 16,
        },
        // Tablet (>= 750px)
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
        },
        // Desktop (>= 990px)
        990: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceBetween,
        },
        // Large Desktop (>= 1200px)
        1200: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween,
        },
      },

      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // Mouse wheel
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },

      // Effects
      effect: 'slide',
      speed: 600,

      // Events
      on: {
        init: function() {
          // Add loaded class for animations
          swiperElement.classList.add('swiper-initialized');
        },
      },
    });

    // Pause autoplay when page is hidden
    if (autoplay && this.swiper) {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.swiper && this.swiper.autoplay) {
          this.swiper.autoplay.stop();
        } else if (this.swiper && this.swiper.autoplay) {
          this.swiper.autoplay.start();
        }
      });
    }
  }

  // Clean up on disconnect
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Register custom element
if (!customElements.get('category-slider')) {
  customElements.define('category-slider', CategorySlider);
}

// Reinitialize on Shopify section reload (Theme Editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('category-slider');
    if (slider && slider.swiper) {
      slider.swiper.destroy(true, true);
      slider.swiper = null;
      slider.init();
    }
  });
}
